import { render, staticRenderFns } from "./teamManagement.vue?vue&type=template&id=8fdfa1c0"
import script from "./teamManagement.vue?vue&type=script&lang=js"
export * from "./teamManagement.vue?vue&type=script&lang=js"
import style0 from "./teamManagement.vue?vue&type=style&index=0&id=8fdfa1c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports